import { service_translate_searches } from '@/services/translate/service_translate_searches';
import { local_search_upsert } from '@/state/search/local_search_upsert';
import { store } from '@/state/store';
import { FN_WORDS__init_in_tokens_search } from '@/state/words/_methods/FN_WORDS__init_in_tokens_search';
import { assert_array_instanceof } from '@shared/asserts/utils_asserts';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { FN_GRID2D__init_possible_features } from '../../_methods/FN_GRID2D__init_possible_features';

export function HANDLER_SEARCH__upsert(items: any) {
  assert_array_instanceof(items, DTOSearchSettings);

  FN_GRID2D__init_possible_features(items);
  FN_WORDS__init_in_tokens_search(items);

  service_translate_searches.on_searches_received(items);

  store.dispatch(local_search_upsert(items));
}
